import brand from '@helpers/brand';
import fonts from '@helpers/fonts';
import { Device, from, until } from '@helpers/media';
import styled, { css } from 'styled-components';

const Container = styled.div``;

const IconHeader = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 5px;
`;

const IconLink = styled.a`
  ${fonts.helvetica['63-medium-extended']};
  font-size: 12px;
  color: ${brand.black};
  display: flex;
  flex-direction: row;
  gap: 0.5ch;
  align-items: center;
  text-decoration: underline;

  @media ${until(Device.Tablet)} {
    margin-top: 25px;
  }

  svg {
    height: 0.7em;
    margin-top: 2px;
  }
`;

const IconTitle = styled.h2<{ hideTitleOnMobile: boolean }>`
  ${fonts.helvetica['55-roman']};
  font-size: 17px;
  text-transform: uppercase;

  ${({ hideTitleOnMobile }) =>
    hideTitleOnMobile
      ? css`
          @media ${until(Device.Tablet)} {
            display: none;
          }
        `
      : css``}
`;

const IconList = styled.div<{ grid: boolean; tab: number | undefined }>`
  margin: 0px 0px 35px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 20px;

  ${({ grid }) => {
    if (grid) {
      return css`
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        gap: 10px;

        @media ${until(Device.Tablet)} {
          grid-template-columns: 1fr;
        }
      `;
    }
  }}

  ${({ tab, grid }) => {
    switch (tab) {
      case 0:
      case 1:
        // Features & Care Icons - two-column grid layout //
        return css`
          @media ${from(Device.Tablet)} {
            ${() => Icon} {
              flex-basis: 30%;
            }
          }

          ${() => IconText} {
            flex-basis: 70%;
          }
        `;

      case 3:
        // Standards - larger icons //
        return css`
          ${grid && `justify-content: center;`}
          ${() => Icon} {
            height: 72px;
            width: 50px;
          }
        `;

      default:
        return css`
          display: flex;
          flex-direction: column;
        `;
    }
  }}
`;

const IconWrapper = styled.div`
  display: flex;
  gap: 20px;
  align-items: center;

  svg {
    max-width: 60px;
  }
`;

const Icon = styled.span`
  height: 85px;
  width: max-content;
  display: block;

  @media ${from(Device.MobileSmall)} {
    height: 65px;
  }

  @media ${from(Device.Tablet)} {
    height: 55px;
  }

  @media ${from(Device.Desktop)} {
    height: 60px;
  }

  @media ${from(Device.DesktopLarge)} {
    height: 50px;
  }

  svg {
    width: 100%;
    height: 100%;
    object-fit: contain;
    color: ${brand.red.base};
  }
`;

const IconText = styled.span`
  ${fonts.helvetica['63-medium-extended']}
  text-align: left;
  color: ${brand.black};
  font-size: 14px;

  @media ${from(Device.Tablet)} {
    font-size: 12px;
  }

  && {
    line-height: 20px;
  }
`;

export const ProductStandardsFeaturesStyles = {
  Container,
  IconHeader,
  IconLink,
  IconTitle,
  IconList,
  IconWrapper,
  IconText,
  Icon,
};
